import { useLocation, useParams } from "react-router-dom";
import UseEditData from "../../../../Components/Hooks/useEditData";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { userRole } from "../Role/RoleData";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton, CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import { NuInput } from "../../../../Components/Utils/Input";

function EditDash() {
    const { editDashId } = useParams()
    const { Oncancel, editData, isLoading } = UseEditData();
    const [roleInfo, setRoleInfo] = useState([]);
    const [createNew, setCreateNew] = useState({
        role: "",
        permissions: []
    });

    const location = useLocation();
    const data = location.state?.data;
    const from = location.state?.from;

      const modulePermissions = {
        "Client Management": 8,
        "Inspection": 38,
        "Commissioning": 49,
        "Refilling": 58,
        "Tickets": 75,
        "Invoice Outgoing": 85,
        "Task": 92,
        "Forms": 98,
        "Email": 100,
        "Contact": 104,
        "Report": 207 
    };

   const formik = useFormik({
  enableReinitialize: true,
  initialValues: createNew,
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: (values, { resetForm }) => {
    const updatedValues = {
      ...values,
      role: values.role?.toLowerCase(),
      permissions: roleInfo
    };

    editData(`/role-permission/multi-update`, updatedValues, resetForm, `/settings/role`);
  }
});


    const selectRow = (name, id) => {
        let testUser;
        if (roleInfo && roleInfo.some((Userid) => Userid === id)) {
            testUser = roleInfo.filter((roleId) => roleId !== id);
            setRoleInfo(testUser);
        } else {
            setRoleInfo([...roleInfo, id]);
        }
    };

    const toggleAllPermissions = (moduleName) => {
        const module = userRole.find(item => item.name === moduleName);
        if (!module) return;

          const modulePermissionIds = module.roles.map(role => role.id);
        
         const allSelected = modulePermissionIds.every(id => 
            roleInfo.includes(id)
        );

        if (allSelected) {
             setRoleInfo(prev => 
                prev.filter(id => !modulePermissionIds.includes(id))
            );
        } else {
              const newPermissions = [...new Set([
                ...roleInfo,
                ...modulePermissionIds,
                modulePermissions[moduleName]
            ])];
            setRoleInfo(newPermissions);
        }
    };

    function GetPermissiom(id) {
        axiosInstance.get(`/role-permission/role/${id}`).then(res => {
            setRoleInfo(res.data?.data?.permissions || [])
        })
    }

    function GetRole(id) {
        axiosInstance.get(`/role/${id}`).then(res => {
            let data = res.data?.data?.roleName;
            setCreateNew({ ...createNew, role: data })
        })
    }

    useEffect(() => {
        if (editDashId) {
            GetRole(editDashId)
            GetPermissiom(editDashId)
        }
    }, [editDashId])

    return (
        <div className='w-full h-full px-4 py-2'>
            <div className='w-full flex justify-between items-center'>
                <Breadcrumb
                    items={[
                        {
                            name: "Role",
                            link: "/settings/role"
                        },
                        {
                            name: "Edit"
                        }
                    ]}
                />
                <BackButton />
            </div>
            <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto px-4 py-2 rounded-md overflow-y-scroll">
                <form onSubmit={formik.handleSubmit}>
                    <div className=" w-full">
                        <label className=" font-semibold text-sm">Role Name:</label>
                        <NuInput
                            disabled={true}
                            name="role"
                            type="text"
                            formik={formik}
                            className={`rounded-lg w-full p-1 outline-none border-2`}
                        />
                    </div>
                    <div className=" w-full">
                        {userRole.map((item, index) => {
                              const allPermissionsSelected = item.roles.every(role => 
                                roleInfo.includes(role.id)
                            );
                            
                            return (
                                <div key={index}>
                                    <div className="flex items-center my-2">
                                       
                                        <p className="font-semibold text-sm">{item.name}</p>
                                         <input
                                            type="checkbox"
                                            className="ml-2 accent-main-blue"
                                            checked={allPermissionsSelected}
                                            onChange={() => toggleAllPermissions(item.name)}
                                        />
                                    </div>
                                    <div className="px-6 grid gap-3 grid-cols-4">
                                        {item.roles.map((role, index) => {
                                            return (
                                                <div key={index} className="w-full bg-slate-100 px-2 py-4 rounded-md text-xs">
                                                    <input
                                                        type="checkbox"
                                                        className="px-3 mr-2 py-2 accent-main-blue"
                                                        checked={roleInfo.some((id) => id === role.id)}
                                                        onChange={() => selectRow(item.name, role.id)}
                                                    />
                                                    <span className="font-medium">{role.name}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="w-full hidden md:block mx-auto my-4 mt-8">
                        <div className="md:flex justify-end gap-4">
                            <CancelButton handleClick={() => { Oncancel(-1) }} />
                            <SubmitButton />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default EditDash